const images = {
    ThenoirImg: require('./../img/noir.png'),
    ThevertImg: require('./../img/vert.png'),

    BoissonSimPle: require('./../img/simple.png'),
    BoissonSimPleSP: require('./../img/simplesansprix.png'),

    BoissonDuo: require('./../img/duo.png'),
    BoissonDuoSP: require('./../img/duosansprix.png'),

    BoissonPerso: require('./../img/Perso.png'),
    BoissonPersoSP: require('./../img/Persosansprix.png'),

    BoissonChef: require('./../img/Chef.png'),
    BoissonChefSP: require('./../img/Chefsansprix.png')
}

const ConfigMenu = {
    Boissons: [],
    Garnitures: [],
    Sucre: [],
    SansGlacons: {},
    Glacons: {},
    init: (cfg) => {
        ConfigMenu.Boissons = cfg.Boissons.map(b => {
            b.imgsp = images[b.imgsp]
            b.img = images[b.img]
            b.taille.map(t => {
                t.The.map(th => {
                    th.img = images[th.img]
                    return th;
                })
            })
            return b;
        })
        ConfigMenu.Garnitures = cfg.Garnitures
        ConfigMenu.Sucre = cfg.Sucre
        ConfigMenu.SansGlacons = cfg.SansGlacons
        ConfigMenu.Glacons = cfg.Glacons
    },
    getBoisson: (ref) => ConfigMenu.Boissons.find(x => x.ref === ref),
    getTaille: (Boisson_ref, Taille_ref) => ConfigMenu.getBoisson(Boisson_ref)?.taille.find(x => x.ref === Taille_ref),
    getThe: (Boisson_ref, Taille_ref, the_ref) => ConfigMenu.getTaille(Boisson_ref, Taille_ref)?.The.find(x => x.ref === the_ref),
    getParfum: (Boisson_ref, Taille_ref, parfum_ref) => ConfigMenu.getTaille(Boisson_ref, Taille_ref)?.parfums.find(x => x.ref === parfum_ref),
    getSucrebyRef: (ref) => ConfigMenu.Sucre.find(x => x.ref === ref),
    getSucrebyValue: (val) => ConfigMenu.Sucre.find(x => x.value === val),
    getGarniture: (ref) => ConfigMenu.Garnitures.find(x => x.ref === ref),
    groupby: (grefs) => JSON.parse(JSON.stringify(grefs.map(gref => ConfigMenu.getGarniture(gref))))
        .reduce((acc, curr) => {
            curr.count = 1;
            let accx = acc.find(x => x.ref === curr.ref)
            if (accx)
                accx.count++
            else
                acc.push(curr);
            return acc;
        }, [])
}

export default ConfigMenu;